module.exports = __webpack_public_path__ + "img/开放学堂浅底logo.a10ed823.png";